export default {
    user : null,
    loggedUser : null
}